// src/components/CookieConsent.js
import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const BannerWrapper = styled(motion.div)`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 600px;
  z-index: 1000;
  
  background: var(--bg-surface);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1rem 1.5rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 10px 40px rgba(0,0,0,0.3);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ConsentText = styled.p`
  margin: 0;
  color: var(--text-secondary-color);
  font-size: 0.9rem;
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

const AcceptButton = styled.button`
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  border: none;
  background-color: var(--primary-color);
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap; /* Button text ko wrap hone se roke */
  margin-left: 1rem;

  &:hover {
    background-color: #536dfe;
    transform: scale(1.05);
  }
`;

const CookieConsent = () => {
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        // Check if user has already given consent
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <BannerWrapper
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 100 }}
                >
                    <ConsentText>
                        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
                    </ConsentText>
                    <AcceptButton onClick={handleAccept}>
                        Accept
                    </AcceptButton>
                </BannerWrapper>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent;